const BoardCard = ({ onClick, board, disabled }) => {
  return (
    <div
      className={[
        "w-full relative flex items-end bg-gray-300",
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:opacity-80"
      ].join(" ")}
      style={{aspectRatio: "3 / 4"}}
      onClick={() => {
        if (disabled) return;
        onClick();
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/images/k-color/boards/${board.cod_board}.jpg`}
        alt=""  // Text is provided below the image
        className="absolute inset-0 z-10"
      />
      <p
        className="text-xl font-semibold z-20 px-3 py-4 leading-none text-white select-none"
        style={{textShadow: "0px 2px 3px rgba(0,0,0,0.75)"}}
      >
        {board.des_board}
      </p>
    </div>
  );
}

export default BoardCard;
